import { render, staticRenderFns } from "./CalendarLegend.vue?vue&type=template&id=4405ed07&scoped=true&"
import script from "./CalendarLegend.vue?vue&type=script&lang=js&"
export * from "./CalendarLegend.vue?vue&type=script&lang=js&"
import style0 from "./CalendarLegend.vue?vue&type=style&index=0&id=4405ed07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405ed07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VExpandTransition})
